import React, { useState, useMemo, useCallback } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";

import LayoutHOC from "../LayoutHOC";
// import { Link } from "react-router-dom";
import useJobsList from "../../hooks/useJobsList";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  usePagination,
  useSortBy,
} from "react-table";
import { useSelector } from "react-redux";
import { DELETE_JOB, UPDATE_JOB_STATUS } from "../../utils/constants";

const StatusToggle = ({ value, id, token }) => {
  const [isActive, setIsActive] = useState(value == 1);

  const handleClick = async () => {
    const newValue = !isActive;
    setIsActive(newValue);
    try {
      const formData = new FormData();
      formData.append("admin_status", newValue ? 1 : 0);
      await fetch(`${UPDATE_JOB_STATUS}${id}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`relative w-12 h-6 rounded-full transition-colors ${isActive ? "bg-emerald-500" : "bg-gray-300"}`}
    >
      <span className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-transform ${isActive ? "left-7" : "left-1"}`}></span>
    </button>
  );
};

const JobsList = () => {
  const positions = useJobsList();
  const [successMessage, setSuccessMessage] = useState("");
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  

  const handleDelete = useCallback(async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this job?");
    if (confirmDelete) {
      try {
        const { token } = user;
        const response = await fetch(`${DELETE_JOB}${id}`, {
          method: "DELETE",
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.ok) {
          setSuccessMessage("Job deleted successfully!");
          navigate("/jobs_list");
          // setTimeout(() => {
          //   setSuccessMessage("");
          //   window.location.reload();
          // }, 1500);
        } else {
          alert("Failed to delete job. Please try again.");
        }
      } catch (error) {
        console.error("Error deleting job:", error);
        alert("Failed to delete job. Please try again.");
      }
    }
  }, [user]);

const determineStatus = (deadline) => {
  if (!deadline) return "Expired";

  let deadlineDate;

  // Format: dd-mm-yyyy
  if (/^\d{2}-\d{2}-\d{4}$/.test(deadline)) {
    const [day, month, year] = deadline.split('-').map(Number);
    deadlineDate = new Date(year, month - 1, day);

  // Format: dd-MMM-yyyy
  } else if (/^\d{2}-[A-Za-z]{3}-\d{4}$/.test(deadline)) {
    const [day, month, year] = deadline.split('-');
    const monthMap = {
      jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
      jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11
    };

    const monthIndex = monthMap[month.toLowerCase()];
    if (monthIndex === undefined) return "Expired";

    deadlineDate = new Date(year, monthIndex, day);
  } else {
    deadlineDate = new Date(deadline);
  }

  if (isNaN(deadlineDate)) return "Expired";

  // Normalize BOTH to date-only
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  deadlineDate.setHours(0, 0, 0, 0);

  return deadlineDate < today ? "Expired" : "Published";
};


  const columns = useMemo(
    () => [
      {
        Header: "Job Info",
        accessor: "categoryRole",
        Cell: ({ cell: { row } }) => {
          const { companylogo, title, jobPosiiton } = row.original;
          return (
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-100 to-indigo-100 flex items-center justify-center overflow-hidden">
                {companylogo ? (
                  <img src={companylogo} alt="Company" className="w-full h-full object-cover" />
                ) : (
                  <i className="bi bi-briefcase text-blue-500"></i>
                )}
              </div>
              <div>
                {/* <div className="font-medium text-gray-900">{title || 'Untitled Job'}</div> */}
                <div className="text-sm text-gray-500">{jobPosiiton || 'Position not specified'}</div>
              </div>
            </div>
          );
        },
      },
      {
        Header: "Employment Type",
        accessor: "employeementType",
        sortType: "alphanumeric",
        Cell: ({ value }) => (
          <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-700">
            {value || 'N/A'}
          </span>
        ),
      },
      {
        Header: "Experience",
        accessor: "experiance",
        sortType: "alphanumeric",
        Cell: ({ value }) => (
          <span className="text-gray-600">{value || 'N/A'}</span>
        ),
      },
      {
        Header: "Salary Range",
        accessor: "salaryRange",
        Cell: ({ row }) => {
          const minSalary = row.original.minSalary;
          const maxSalary = row.original.maxSalary;
          return (
            <span className="text-gray-700 font-medium">
              {minSalary && maxSalary ? `₹${minSalary} - ₹${maxSalary}` : 'N/A'}
            </span>
          );
        },
      },
      {
        Header: "Deadline",
        accessor: "deadline",
        sortType: "alphanumeric",
        Cell: ({ value }) => (
          <span className="text-gray-600">{value || 'N/A'}</span>
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) => {
          const deadlineStatus = determineStatus(row.original.deadline);
          // const jobStatus = row.original.status;
          let displayStatus = deadlineStatus;
          // if (jobStatus == 0) {
          //   if (deadlineStatus === "Expired") {
          //     displayStatus = "Expired Not Published";
          //   } else {
          //     displayStatus = "Not Published";
          //   }
          // }
          const isPublished = displayStatus === "Published";
          return (
            <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${
              isPublished
                ? "bg-emerald-100 text-emerald-700"
                : "bg-red-100 text-red-700"
            }`}>
              <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
                isPublished ? "bg-emerald-500" : "bg-red-500"
              }`}></span>
              {displayStatus}
            </span>
          );
        },
      },
      {
        Header: "Admin Status",
        accessor: "admin_status",
        Cell: ({ value, row }) => (
          <StatusToggle value={value} id={row.original.id} token={user.token} />
        ),
      },
      {
        Header: "Actions",
        accessor: "id",
        Cell: ({ row }) => (
          <div className="flex items-center gap-2">
            <Link
              to={`/job_details/${row.values.id}`}
              className="inline-flex items-center gap-1 px-3 py-1.5 bg-green-50 text-green-600 rounded-lg hover:bg-green-100 transition-colors text-sm font-medium"
            >
              <i className="bi bi-eye"></i>
              View
            </Link>
            <Link
              to={`/edit_job/${row.values.id}`}
              className="inline-flex items-center gap-1 px-3 py-1.5 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors text-sm font-medium"
            >
              <i className="bi bi-pencil"></i>
              Edit
            </Link>
            <button
              onClick={() => handleDelete(row.values.id)}
              className="inline-flex items-center gap-1 px-3 py-1.5 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors text-sm font-medium"
            >
              <i className="bi bi-trash"></i>
              Delete
            </button>
          </div>
        ),
      },
    ],
    [handleDelete]
  );

  const data = useMemo(() => positions?.data || [], [positions]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state,
    setGlobalFilter,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    setPageSize,
  } = useTable(
    { columns, data, initialState: { pageSize: 10 } },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { globalFilter, pageIndex, pageSize } = state;

  return (
    <main id="maincontent">
      <div className="p-6 mt-14 min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
        <div className="mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-3 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl shadow-lg">
                <i className="bi bi-briefcase text-white text-2xl"></i>
              </div>
              <div>
                <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-800 to-indigo-600 bg-clip-text text-transparent">
                  Jobs List
                </h1>
                <p className="text-gray-500">Manage all job postings and listings</p>
              </div>
            </div>
            <Link
              to="/create_job"
              className="inline-flex items-center gap-2 px-5 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-xl hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg font-medium"
            >
              <i className="bi bi-plus-lg"></i>
              Create Job
            </Link>
          </div>
        </div>

        {successMessage && (
          <div className="mb-6 p-4 bg-emerald-50 border border-emerald-200 rounded-xl flex items-center gap-3">
            <i className="bi bi-check-circle-fill text-emerald-500 text-xl"></i>
            <span className="text-emerald-700 font-medium">{successMessage}</span>
          </div>
        )}

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="p-4 border-b border-gray-100 flex flex-wrap items-center justify-between gap-4">
            <div className="relative">
              <i className="bi bi-search absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                placeholder="Search jobs..."
                value={globalFilter || ""}
                onChange={(e) => setGlobalFilter(e.target.value)}
                className="pl-11 pr-4 py-2.5 border border-gray-200 rounded-xl w-72 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              />
            </div>
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-500">Show</span>
              <select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
                className="px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500"
              >
                {[10, 25, 50, 100].map((size) => (
                  <option key={size} value={size}>{size}</option>
                ))}
              </select>
              <span className="text-sm text-gray-500">entries</span>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full" {...getTableProps()}>
              <thead className="bg-gradient-to-r from-blue-50 to-indigo-50">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider cursor-pointer hover:bg-blue-100/50 transition-colors"
                        {...column.getHeaderProps(column.getSortByToggleProps())}
                      >
                        <div className="flex items-center gap-2">
                          {column.render("Header")}
                          <span className="text-blue-400">
                            {column.isSorted ? (column.isSortedDesc ? "↓" : "↑") : ""}
                          </span>
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody className="divide-y divide-gray-100" {...getTableBodyProps()}>
                {page.length === 0 ? (
                  <tr>
                    <td colSpan={columns.length} className="px-6 py-12 text-center">
                      <div className="flex flex-col items-center gap-3">
                        <i className="bi bi-briefcase text-4xl text-gray-300"></i>
                        <p className="text-gray-500">No jobs found</p>
                        <Link to="/create_job" className="text-blue-500 hover:underline">
                          Create your first job posting
                        </Link>
                      </div>
                    </td>
                  </tr>
                ) : (
                  page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr className="hover:bg-blue-50/30 transition-colors" {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td className="px-6 py-4 text-sm text-gray-700" {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {page.length > 0 && (
            <div className="p-4 border-t border-gray-100 flex flex-wrap items-center justify-between gap-4">
              <div className="text-sm text-gray-500">
                Showing <span className="font-medium">{pageIndex * pageSize + 1}</span> to{" "}
                <span className="font-medium">{Math.min((pageIndex + 1) * pageSize, data.length)}</span>{" "}
                of <span className="font-medium">{data.length}</span> results
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => gotoPage(0)} disabled={!canPreviousPage} className="p-2 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                  <i className="bi bi-chevron-double-left"></i>
                </button>
                <button onClick={() => previousPage()} disabled={!canPreviousPage} className="px-4 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-medium">
                  Previous
                </button>
                <div className="flex items-center gap-1">
                  {pageOptions.slice(Math.max(0, pageIndex - 2), Math.min(pageOptions.length, pageIndex + 3)).map((pg) => (
                    <button
                      key={pg}
                      onClick={() => gotoPage(pg)}
                      className={`w-10 h-10 rounded-lg text-sm font-medium transition-colors ${pageIndex === pg ? "bg-blue-500 text-white" : "hover:bg-gray-100 text-gray-600"}`}
                    >
                      {pg + 1}
                    </button>
                  ))}
                </div>
                <button onClick={() => nextPage()} disabled={!canNextPage} className="px-4 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-medium">
                  Next
                </button>
                <button onClick={() => gotoPage(pageOptions.length - 1)} disabled={!canNextPage} className="p-2 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                  <i className="bi bi-chevron-double-right"></i>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default LayoutHOC(JobsList);
